<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg570"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs574"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath584"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path582" /></clipPath></defs><g
     id="g576"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g578"><g
         id="g580"
         clip-path="url(#clipPath584)"><g
           id="g586"
           transform="translate(110,210)"><path
             d="m 0,0 -83.2,136.51 c -10.61,15.88 -16.8,34.96 -16.8,55.49 0,55.23 44.77,100 100,100 55.23,0 100,-44.77 100,-100 0,-20.53 -6.19,-39.61 -16.8,-55.49 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path588" /></g><g
           id="g590"
           transform="translate(150,402)"><path
             d="m 0,0 c 0,-22.09 -17.91,-40 -40,-40 -22.09,0 -40,17.91 -40,40 0,22.09 17.91,40 40,40 C -17.91,40 0,22.09 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path592" /></g><g
           id="g594"
           transform="translate(402,50)"><path
             d="m 0,0 c 11.05,0 20,-8.96 20,-20 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.04 8.95,20 20,20 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path596" /></g><g
           id="g598"
           transform="translate(402,50)"><path
             d="m 0,0 -83.2,130.51 c -10.61,15.88 -16.8,34.96 -16.8,55.49 0,55.23 44.77,100 100,100 55.23,0 100,-44.77 100,-100 0,-20.53 -6.19,-39.61 -16.8,-55.49 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path600" /></g><g
           id="g602"
           transform="translate(442,236)"><path
             d="m 0,0 c 0,-22.09 -17.91,-40 -40,-40 -22.09,0 -40,17.91 -40,40 0,22.09 17.91,40 40,40 C -17.91,40 0,22.09 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path604" /></g><g
           id="g606"
           transform="translate(130,190)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.04 8.95,20 20,20 C -8.95,20 0,11.04 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path608" /></g><g
           id="g610"
           transform="translate(251,30)"><path
             d="m 0,0 c 0,-5.523 -4.477,-10 -10,-10 -5.523,0 -10,4.477 -10,10 0,5.523 4.477,10 10,10 C -4.477,10 0,5.523 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path612" /></g><g
           id="g614"
           transform="translate(130,190)"><path
             d="m 0,0 h 86 c 22.09,0 40,-17.91 40,-40 0,-22.09 -17.91,-40 -40,-40 H -34 c -22.09,0 -40,-17.91 -40,-40 0,-22.09 17.91,-40 40,-40 H 66"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path616" /></g><g
           id="g618"
           transform="translate(286,30)"><path
             d="M 0,0 H 96"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path620" /></g></g></g></g></svg>
</template>
